export default "__VITE_ASSET__bgO3KlsK__"